import React, { useState } from 'react';
import TinderCard from 'react-tinder-card';

import './Test.css';

const Test = ({questions, handleSwipe, name, mark, handleOptionClicked,clickOption}) => {

    return (
        <>
        {questions.length > 0 && localStorage.getItem('write') != 'yes'?
         <div className="test-container" >
            <div className="swip" onClick={() => handleSwipe()}>Next Question</div>
            {questions.map(( question) =>(
                <div className='swipe-card' onSwipe={() => {handleSwipe()}} >
                <div className="test" key={question.id} >
                    <sup key={question.id+2} >{question.id}</sup>
                    {clickOption.length > 0 && <h6><div>Your Answer : </div> {clickOption}</h6>}
                    <div className="test-header" key={question.question}>{question.question}</div>
                    <div className="options">
                        {question.options.map((option, i) =>(
                            <div className="option" key={i+1}  onClick={()=> handleOptionClicked(option , question.correct)} >{option}</div>
                        ))}
                    </div>
                    
                </div>
                </div>
            ))}
            
        </div> : 
        <div className="answer" > <h1>Hey! {localStorage.getItem('name')} <br/>You Got : { parseInt(localStorage.getItem('mark'))} out of 59</h1><h4>Take a picture/screenshow and Send to Derrick</h4></div>}
       
        </>
    )
}

export default Test
